(function () {
  if (window.__monetaHomeInit) return;
  window.__monetaHomeInit = true;

  var items = document.querySelectorAll('.mh-rev, .mh-row');
  if (items.length) {
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      Array.prototype.forEach.call(items, function (el) { obs.observe(el); });
    } else {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
    }
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-mh-show]'), function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mh-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-mh-panel]'));
    if (!tabs.length) return;
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, j) {
          t.classList.toggle('is-on', i === j);
          t.setAttribute('aria-selected', i === j ? 'true' : 'false');
        });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
      });
    });
  });

  Array.prototype.forEach.call(document.querySelectorAll('[data-mh-steps]'), function (root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-mh-step]'));
    var shots = Array.prototype.slice.call(root.querySelectorAll('[data-mh-shot]'));
    var ghost = root.querySelector('[data-mh-ghost]');
    if (!steps.length) return;
    var current = 0;
    var timer = null;
    var delay = 7000;

    function show(i) {
      current = i;
      steps.forEach(function (s, j) {
        s.classList.toggle('is-on', i === j);
        var btn = s.querySelector('.mh-step__btn');
        if (btn) btn.setAttribute('aria-expanded', i === j ? 'true' : 'false');
        var bar = s.querySelector('.mh-step__bar span');
        if (bar && i === j) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      });
      shots.forEach(function (img, j) { img.classList.toggle('is-on', i === j); });
      if (ghost) ghost.textContent = ('0' + (i + 1)).slice(-2);
    }

    function start() {
      stop();
      timer = setInterval(function () { show((current + 1) % steps.length); }, delay);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    steps.forEach(function (s, i) {
      var btn = s.querySelector('.mh-step__btn');
      if (!btn) return;
      btn.addEventListener('click', function () { show(i); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    show(0);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { start(); } else { stop(); } });
      }, { threshold: 0.25 });
      io.observe(root);
    } else {
      start();
    }
  });
})();
